import styled from 'styled-components';

import Grid from '@ui/atoms/Grid';

import theme from '@theme/FolxTheme';

const FlowGrid = styled(Grid)`
	margin-top: ${theme.spacing.lgxl};
	overflow-x: hidden;
`;

export default FlowGrid;
